export default __webpack_public_path__ + "static/media/name.c69c3020.svg";